module.exports = __webpack_public_path__ + "static/media/folder-1.c7608943.svg";